import { Quote } from "lucide-react";

// Quote motivasi berdasarkan kategori rata-rata skor simulasi/TryOut.
// A (>=60): hijau · B (50-59): kuning · C (<50): oranye.
export default function MotivasiQuote({ skor, className = "" }) {
  if (skor === null || skor === undefined || skor === "") return null;
  const s = Number(skor);
  if (Number.isNaN(s)) return null;
  const q = s >= 60
    ? { key: "A", label: "Momentum Bagus", ic: "text-[#4A6B53]", bg: "bg-[#4A6B53]/10", br: "border-[#4A6B53]/40",
        text: "Kerja kerasmu mulai terlihat, Talenta Muda Indonesia! Pertahankan momentum ini — konsistensi adalah kunci untuk bersaing di prodi terbaik pilihanmu." }
    : s >= 50
    ? { key: "B", label: "Terus Melaju", ic: "text-[#B8860B]", bg: "bg-[#F4B942]/15", br: "border-[#F4B942]/50",
        text: "Kamu sudah di jalur yang benar, Talenta Muda Indonesia! Satu langkah lagi, dan pintu PTN impianmu terbuka lebih lebar — terus asah, hasilnya pasti mengikuti." }
    : { key: "C", label: "Langkah Awal", ic: "text-[#E25E3E]", bg: "bg-[#E25E3E]/10", br: "border-[#E25E3E]/40",
        text: "Talenta Muda Indonesia! Setiap skor adalah titik awal, bukan titik akhir. Yang penting bukan di mana kamu mulai, tapi seberapa jauh kamu mau melangkah." };
  return (
    <div data-testid="tryout-motivasi-quote" data-kategori={q.key}
      className={`clay-card p-6 text-left border ${q.br} ${q.bg} animate-fade-in-up ${className}`}>
      <div className="flex items-start gap-3">
        <Quote className={`h-7 w-7 shrink-0 ${q.ic}`} />
        <div>
          <p className={`text-xs font-bold uppercase tracking-wide mb-1.5 ${q.ic}`}>{q.label}</p>
          <p className="text-[#1A1C1A] text-base leading-relaxed font-medium italic">“{q.text}”</p>
        </div>
      </div>
    </div>
  );
}
